'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-130a177d.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var SvgReferAFriend = function (_a) {
    var _b = _a.active, active = _b === void 0 ? false : _b, props = tslib_es6.__rest(_a, ["active"]);
    var computedProps = tslib_es6.__assign({ width: 20, height: 20, fill: 'currentColor' }, props);
    return (React__default['default'].createElement("svg", tslib_es6.__assign({ viewBox: "0 0 20 20" }, computedProps, { stroke: "none" }),
        active ? (React__default['default'].createElement("path", { className: "active", fillRule: "evenodd", d: "M2 8H18V19H2V8Z", fill: "currentColor" })) : (React__default['default'].createElement("path", { fillRule: "evenodd", d: "M2 8H18V19H2V8ZM3 9H17V18H3V9Z" })),
        React__default['default'].createElement("rect", { x: "2", y: "8", width: "16", height: "1" }),
        React__default['default'].createElement("path", { fillRule: "evenodd", d: "M6 7H10.5C10.3693 6.65148 10.2462 6.31815 10.1287 6C8.89769 2.66667 8.28218 1 6 1C4.34315 1 3 2.34315 3 4C3 5.65685 4.34315 7 6 7ZM6.20003 5.99999H9.00003C7.90003 3.06666 7.50003 1.99999 6.20003 1.99999C4.985 1.99999 4.00003 2.78497 4.00003 3.99999C4.00003 5.21502 4.985 5.99999 6.20003 5.99999Z" }),
        React__default['default'].createElement("path", { fillRule: "evenodd", d: "M14 7H9.5C9.63069 6.65148 9.7538 6.31815 9.87129 6C11.1023 2.66667 11.7178 1 14 1C15.6569 1 17 2.34315 17 4C17 5.65685 15.6569 7 14 7ZM13.8 5.99999H11C12.1 3.06666 12.5 1.99999 13.8 1.99999C15.015 1.99999 16 2.78497 16 3.99999C16 5.21502 15.015 5.99999 13.8 5.99999Z" }),
        React__default['default'].createElement("rect", { x: "1.5", y: "6.5", width: "17", height: "2", fill: "none", stroke: "currentColor" })));
};
var ReferAFriend = function (_a) {
    var props = tslib_es6.__rest(_a, []);
    return React__default['default'].createElement(SvgReferAFriend, tslib_es6.__assign({}, props));
};
var ReferAFriendActive = function (_a) {
    var props = tslib_es6.__rest(_a, []);
    return React__default['default'].createElement(SvgReferAFriend, tslib_es6.__assign({}, props, { active: true }));
};
ReferAFriendActive.displayName = 'ReferAFriend.Active';
ReferAFriend.Active = ReferAFriendActive;

exports.default = ReferAFriend;
//# sourceMappingURL=index.js.map
